import configNuxtUi from '~/modules/design-system/utils/nuxt-ui-config'

export default defineAppConfig({
  ui: configNuxtUi,
})
